import { LandingPageContent } from './landingPageContent'

export { LandingPageContent }
